import {
  SET_SITE_VIEWER_VERSION_META,
  DISMISS_SITE_VIEWER_VERSION_UPGRADE
} from 'zoomforth_codesbane_editor/action_types.js';


export default (state = {}, action)=> {

  switch (action.type) {

  case SET_SITE_VIEWER_VERSION_META:
    return {
      ...state,
      isUpgradeAvailable: action.isUpgradeAvailable,
      hasUserDismissedUpgrade: action.hasUseDismissedUpgrade
    };

  case DISMISS_SITE_VIEWER_VERSION_UPGRADE:
    return {
      ...state,
      hasUserDismissedUpgrade: true
    };

  default:
    return state;

  }
};

export const getIsSiteViewerVersionUpgradeAvailable = (state)=>
  !!state.isUpgradeAvailable;

export const getHasUserDismissedSiteViewerVersionUpgrade = (state)=>
  !!state.hasUserDismissedUpgrade;
